const _excluded = ["elsterYear", "value", "onChange", "disabled", "dataTestId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import Dropdown from '@rd-web-markets/shared/dist/util/Dropdown';
import { HALF_YEAR_OPTIONS_BY_ELSTER_YEAR } from '../../constants';

/**
 * Dropdown for half-year / elster year selection. Options depend on elsterYear (2020 vs 2024).
 * When elsterYear is null/undefined, nothing is rendered.
 * Used in StaffCostsTableData and NameListTableData when elster year is set.
 */
const HalfYearDropdown = _ref => {
  var _HALF_YEAR_OPTIONS_BY;
  let {
      elsterYear,
      value,
      onChange,
      disabled,
      dataTestId = 'half_year_dropdown'
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (elsterYear == null) {
    return null;
  }
  const options = (_HALF_YEAR_OPTIONS_BY = HALF_YEAR_OPTIONS_BY_ELSTER_YEAR[elsterYear]) !== null && _HALF_YEAR_OPTIONS_BY !== void 0 ? _HALF_YEAR_OPTIONS_BY : HALF_YEAR_OPTIONS_BY_ELSTER_YEAR[2024];
  return /*#__PURE__*/React.createElement(Dropdown, _extends({
    name: "year",
    fieldName: "year",
    value: value,
    onChange: onChange,
    disabled: disabled,
    options: options,
    showNullOption: false,
    dataTestId: dataTestId,
    style: {
      width: '150px'
    }
  }, rest));
};
export default HalfYearDropdown;
export { HALF_YEAR_OPTIONS_BY_ELSTER_YEAR };